<template>
    <div class="solve">
        <div class="solve-content">
            <div class="solve-img1">
                <div class="content" style="text-indent:2em;">
                    提供专业的电力综合服务解决方案，帮助企业应对市场变革与竞争挑战，快速搭建标准化或定制化商业平台，实现业务应用的灵活开发与落地，构建能源互联新生态。
                </div>
            </div>
            <!-- <div class="container solve-img2">
                <div class="content-wrap">
                    中恒善能基于长期积累的电力行业经验及对国内各项方案的深刻理解，打造了新能源快频响应系统，可有效使得新能源场站能够自身具备一定的调节能力，在新能源大发展的时期不增加水火电调峰调频的基础上满足电网安全的要求。该系统主要功能包括当电力系统频率超偏离目标频率时，发电机组通过自动反应，调整有功出力减少频率偏差的过程，自动地降低或增加机组出力。
                </div>
            </div> -->
            <div class="solve-img-outwrap">
                <div class="container solve-img3">
                    <div class="content-wrap">
                        发电企业辅助决策系统解决方案可为用户搭建智能化、精细化、 数据化、移动化大数据平台，也可以通过平台为用户提供有序售电方案设计，机组发电运行方案、环保指标评估、机组启停检测、两个细则管理等专项第三方服务。
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss">
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
} 

// common.css
.container  {
    margin: auto;
    max-width: 1200px;
    min-width: 1200px;
}

.solve-content {
    .content-wrap {
        color: #666;
        font-size: 14px;
        line-height: 22px;
        max-width: 512px;
        margin-bottom: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: left;
    }

    .solve-img1 {
        width: 100%;
        height: 405px;
        background: url(../assets/img/bgtop_solve.jpg) center;

        .content {
            width: 726px;
            margin: 0 auto;
            padding-top: 200px;
            color: #666;
            font-size: 14px;
        }
    }

    .solve-img2 {
        position: relative;
        width: 100%;
        height: 599px;
        background: url(../assets/img/solve_img2.jpg) center;

        .content-wrap {
            position: absolute;
            left: 100px;
            top: 282px;
        }
    }

    .solve-img-outwrap {
        width: 100%;
        background-color: #fcfcfc;
    }

    .solve-img3 {
        positon: relative;
        width: 100%;
        height: 599px;
        background: url(../assets/img/solve_img3.jpg) center;

        .content-wrap {
            position: absolute;
            right: 250px;
            margin-top: 300px;
        }
    }


   
}


</style>